var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{mask:url(#mask);}.cls-3{filter:url(#luminosity-noclip);}.cls-4{fill:#fff;}.cls-5{fill:#fff5ec;}.cls-6{fill:#3c3c3b;}.cls-7{fill:#504657;}.cls-8{mix-blend-mode:multiply;}.cls-9{isolation:isolate;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: -1.96,
    y: -17.64,
    width: 515.68,
    height: 535.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 501.91,
    x2: 2,
    y2: 501.91,
    gradientTransform: "translate(-127791.11 -9.24) rotate(90) scale(255.12 -255.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -1.96,
    y: -17.64,
    width: 515.68,
    height: 535.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.96,
    y: -17.64,
    width: 515.68,
    height: 535.28
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    width: 500,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m55.56,39.4c-3.96,0-7.05,1.62-9.26,4.86-2.22,3.24-3.33,7.71-3.33,13.41,0,11.85,4.51,17.77,13.52,17.77,2.72,0,5.36-.38,7.92-1.14,2.55-.76,5.12-1.67,7.71-2.74v14.06c-5.14,2.27-10.95,3.41-17.43,3.41-9.29,0-16.41-2.69-21.37-8.08-4.96-5.39-7.43-13.18-7.43-23.37,0-6.37,1.2-11.97,3.6-16.8,2.4-4.83,5.85-8.54,10.36-11.14,4.51-2.6,9.8-3.89,15.9-3.89,6.65,0,13.01,1.45,19.07,4.34l-5.09,13.1c-2.27-1.07-4.55-1.96-6.82-2.69-2.27-.73-4.72-1.09-7.33-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.89,88.2V26.64h16.72v61.56h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m132.75,88.2h-16.63v-47.96h-15.03v-13.6h46.65v13.6h-14.99v47.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m152.32,88.2V26.64h16.72v61.56h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m221.91,88.2h-47.96v-10.27l26.65-37.85h-26.02v-13.43h46.65v10.23l-26.65,37.9h27.33v13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m263.03,88.2h-36.55V26.64h36.55v13.35h-19.92v9.68h18.44v13.35h-18.44v11.62h19.92v13.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m328.2,88.2h-21.81l-22.48-43.37h-.38c.53,6.82.8,12.03.8,15.62v27.75h-14.74V26.64h21.73l22.4,42.78h.25c-.39-6.2-.59-11.19-.59-14.95v-27.83h14.82v61.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m377.53,69.51c0,3.82-.97,7.21-2.91,10.17-1.94,2.96-4.73,5.26-8.38,6.91-3.65,1.64-7.93,2.46-12.84,2.46-4.1,0-7.54-.29-10.32-.86s-5.67-1.58-8.67-3.01v-14.82c3.17,1.63,6.47,2.9,9.9,3.81,3.42.91,6.57,1.37,9.43,1.37,2.47,0,4.28-.43,5.43-1.28,1.15-.86,1.73-1.96,1.73-3.31,0-.84-.23-1.58-.69-2.21s-1.21-1.27-2.23-1.92c-1.03-.64-3.76-1.96-8.19-3.96-4.02-1.82-7.03-3.59-9.03-5.31-2.01-1.71-3.49-3.68-4.46-5.89-.97-2.22-1.45-4.84-1.45-7.87,0-5.67,2.06-10.09,6.19-13.26,4.13-3.17,9.8-4.76,17.01-4.76,6.37,0,12.87,1.47,19.5,4.42l-5.09,12.84c-5.76-2.64-10.72-3.96-14.91-3.96-2.16,0-3.73.38-4.72,1.14-.98.76-1.47,1.7-1.47,2.82,0,1.21.62,2.29,1.87,3.24,1.25.96,4.64,2.69,10.17,5.22,5.31,2.39,8.99,4.95,11.05,7.68s3.09,6.18,3.09,10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m396.17,26.73l.63.93c-2.58,10.27-5.07,18.15-7.45,23.62h-11.71c1.91-8.9,3.28-17.08,4.13-24.55h14.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.82,165.81H29.27v-61.56h36.55v13.35h-19.92v9.68h18.44v13.35h-18.44v11.62h19.92v13.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m99.79,117.01c-3.96,0-7.05,1.62-9.26,4.86-2.22,3.24-3.33,7.71-3.33,13.41,0,11.85,4.51,17.77,13.52,17.77,2.72,0,5.36-.38,7.92-1.14,2.55-.76,5.12-1.67,7.71-2.74v14.06c-5.14,2.27-10.95,3.41-17.43,3.41-9.29,0-16.41-2.69-21.37-8.08-4.96-5.39-7.43-13.18-7.43-23.37,0-6.37,1.2-11.97,3.6-16.8,2.4-4.83,5.85-8.54,10.36-11.14,4.51-2.6,9.8-3.89,15.9-3.89,6.65,0,13.01,1.45,19.07,4.34l-5.09,13.1c-2.27-1.07-4.55-1.96-6.82-2.69-2.27-.73-4.72-1.09-7.33-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m181.71,134.95c0,10.36-2.54,18.23-7.62,23.62-5.08,5.39-12.52,8.08-22.32,8.08s-17.06-2.71-22.21-8.13c-5.15-5.42-7.73-13.31-7.73-23.66s2.56-18.07,7.68-23.47c5.12-5.4,12.57-8.11,22.34-8.11s17.22,2.68,22.27,8.04c5.05,5.36,7.58,13.24,7.58,23.62Zm-42.36,0c0,11.9,4.14,17.85,12.42,17.85,4.21,0,7.33-1.45,9.37-4.34,2.03-2.89,3.05-7.4,3.05-13.52s-1.03-10.69-3.09-13.62c-2.06-2.93-5.14-4.4-9.24-4.4-8.34,0-12.51,6.01-12.51,18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m247.21,165.81h-21.81l-22.48-43.37h-.38c.53,6.82.8,12.03.8,15.62v27.75h-14.74v-61.56h21.73l22.4,42.78h.25c-.39-6.2-.59-11.19-.59-14.95v-27.83h14.82v61.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m313.9,134.95c0,10.36-2.54,18.23-7.62,23.62-5.08,5.39-12.52,8.08-22.32,8.08s-17.06-2.71-22.21-8.13c-5.15-5.42-7.73-13.31-7.73-23.66s2.56-18.07,7.68-23.47c5.12-5.4,12.57-8.11,22.34-8.11s17.22,2.68,22.27,8.04c5.05,5.36,7.58,13.24,7.58,23.62Zm-42.36,0c0,11.9,4.14,17.85,12.42,17.85,4.21,0,7.33-1.45,9.37-4.34,2.03-2.89,3.05-7.4,3.05-13.52s-1.03-10.69-3.09-13.62c-2.06-2.93-5.14-4.4-9.24-4.4-8.34,0-12.51,6.01-12.51,18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m347.61,165.81l-12.59-44.34h-.38c.59,7.55.88,13.42.88,17.6v26.74h-14.74v-61.56h22.15l12.84,43.71h.34l12.59-43.71h22.19v61.56h-15.28v-26.99c0-1.4.02-2.96.06-4.67.04-1.71.23-5.91.57-12.59h-.38l-12.42,44.25h-15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m399.93,165.81v-61.56h16.72v61.56h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m453.05,117.01c-3.96,0-7.05,1.62-9.26,4.86s-3.33,7.71-3.33,13.41c0,11.85,4.51,17.77,13.52,17.77,2.72,0,5.36-.38,7.92-1.14,2.55-.76,5.12-1.67,7.71-2.74v14.06c-5.14,2.27-10.95,3.41-17.43,3.41-9.29,0-16.41-2.69-21.37-8.08s-7.43-13.18-7.43-23.37c0-6.37,1.2-11.97,3.6-16.8,2.4-4.83,5.85-8.54,10.36-11.14,4.51-2.6,9.8-3.89,15.9-3.89,6.65,0,13.01,1.45,19.07,4.34l-5.09,13.1c-2.27-1.07-4.55-1.96-6.82-2.69-2.27-.73-4.72-1.09-7.33-1.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m55.56,194.63c-3.96,0-7.05,1.62-9.26,4.86-2.22,3.24-3.33,7.71-3.33,13.41,0,11.85,4.51,17.77,13.52,17.77,2.72,0,5.36-.38,7.92-1.14,2.55-.76,5.12-1.67,7.71-2.74v14.06c-5.14,2.27-10.95,3.41-17.43,3.41-9.29,0-16.41-2.69-21.37-8.08-4.96-5.39-7.43-13.18-7.43-23.37,0-6.37,1.2-11.97,3.6-16.8,2.4-4.83,5.85-8.54,10.36-11.14,4.51-2.6,9.8-3.89,15.9-3.89,6.65,0,13.01,1.45,19.07,4.34l-5.09,13.1c-2.27-1.07-4.55-1.96-6.82-2.69-2.27-.73-4.72-1.09-7.33-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m137.49,212.56c0,10.36-2.54,18.23-7.62,23.62-5.08,5.39-12.52,8.08-22.32,8.08s-17.06-2.71-22.21-8.13c-5.15-5.42-7.73-13.31-7.73-23.66s2.56-18.07,7.68-23.47c5.12-5.4,12.57-8.11,22.34-8.11s17.22,2.68,22.27,8.04c5.05,5.36,7.58,13.24,7.58,23.62Zm-42.36,0c0,11.9,4.14,17.85,12.42,17.85,4.21,0,7.33-1.45,9.37-4.34,2.03-2.89,3.05-7.4,3.05-13.52s-1.03-10.69-3.09-13.62c-2.06-2.93-5.14-4.4-9.24-4.4-8.34,0-12.51,6.01-12.51,18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m196.72,181.87v37.05c0,8.06-2.28,14.3-6.84,18.72-4.56,4.42-11.14,6.63-19.73,6.63s-14.84-2.15-19.35-6.44-6.76-10.47-6.76-18.53v-37.43h16.72v36.13c0,4.35.81,7.51,2.44,9.47,1.63,1.97,4.03,2.95,7.2,2.95,3.4,0,5.86-.97,7.39-2.93,1.53-1.95,2.29-5.14,2.29-9.58v-36.04h16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m264.03,243.43h-21.81l-22.48-43.37h-.38c.53,6.82.8,12.03.8,15.62v27.75h-14.74v-61.56h21.73l22.4,42.78h.25c-.39-6.2-.59-11.19-.59-14.95v-27.83h14.82v61.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m300.52,194.63c-3.96,0-7.05,1.62-9.26,4.86s-3.33,7.71-3.33,13.41c0,11.85,4.51,17.77,13.52,17.77,2.72,0,5.36-.38,7.92-1.14s5.12-1.67,7.71-2.74v14.06c-5.14,2.27-10.95,3.41-17.43,3.41-9.29,0-16.41-2.69-21.37-8.08s-7.43-13.18-7.43-23.37c0-6.37,1.2-11.97,3.6-16.8,2.4-4.83,5.85-8.54,10.36-11.14,4.51-2.6,9.8-3.89,15.9-3.89,6.65,0,13.01,1.45,19.07,4.34l-5.09,13.1c-2.27-1.07-4.55-1.96-6.82-2.69-2.27-.73-4.72-1.09-7.33-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m324.85,243.43v-61.56h16.72v61.56h-16.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m350.56,243.43v-61.56h16.63v48.13h23.71v13.43h-40.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.25,389.03c0,7.99-2,14.31-5.99,18.97s-9.51,6.98-16.54,6.98-12.51-2.33-16.5-6.98-5.99-11-5.99-19.03,2.02-14.33,6.05-18.93,9.54-6.91,16.52-6.91,12.53,2.31,16.5,6.94,5.96,10.95,5.96,18.97Zm-41.2,0c0,7.21,1.61,12.79,4.82,16.73s7.83,5.91,13.85,5.91,10.7-1.95,13.9-5.86,4.81-9.5,4.81-16.78-1.6-12.82-4.81-16.69-7.81-5.8-13.83-5.8-10.62,1.95-13.87,5.86-4.87,9.45-4.87,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m114.92,414.28h-3.55l-29.83-44.72h-.28c.28,5.33.41,9.35.41,12.06v32.66h-3.38v-50.37h3.51l29.8,44.65h.21c-.21-4.13-.31-8.06-.31-11.78v-32.87h3.41v50.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.66,414.28h-3.55v-47.06h-16.36v-3.31h36.28v3.31h-16.36v47.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m210.52,414.28h-3.55v-24.77h-29.42v24.77h-3.51v-50.37h3.51v22.36h29.42v-22.36h3.55v50.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.78,414.28h-27.53v-50.37h27.53v3.24h-24.01v19.05h22.67v3.24h-22.67v21.6h24.01v3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m293.1,366.36c-6.32,0-11.29,2.02-14.92,6.06-3.63,4.04-5.44,9.58-5.44,16.61s1.71,12.77,5.13,16.74c3.42,3.97,8.32,5.96,14.68,5.96,4.23,0,8.11-.54,11.64-1.62v3.1c-3.33,1.17-7.49,1.76-12.47,1.76-7.07,0-12.64-2.29-16.71-6.86-4.07-4.57-6.1-10.96-6.1-19.15,0-5.12.97-9.63,2.91-13.54s4.73-6.92,8.37-9.04c3.64-2.12,7.87-3.19,12.7-3.19s9.31.92,13.19,2.76l-1.41,3.17c-3.67-1.84-7.53-2.76-11.58-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m354.24,389.03c0,7.99-2,14.31-5.99,18.97s-9.51,6.98-16.54,6.98-12.51-2.33-16.5-6.98-5.99-11-5.99-19.03,2.02-14.33,6.05-18.93c4.03-4.6,9.54-6.91,16.52-6.91s12.53,2.31,16.5,6.94,5.96,10.95,5.96,18.97Zm-41.2,0c0,7.21,1.61,12.79,4.82,16.73s7.83,5.91,13.85,5.91,10.7-1.95,13.9-5.86,4.81-9.5,4.81-16.78-1.6-12.82-4.81-16.69-7.81-5.8-13.83-5.8-10.62,1.95-13.87,5.86-4.87,9.45-4.87,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m390.08,401.29c0,4.2-1.54,7.53-4.63,9.99s-7.19,3.69-12.32,3.69c-6.16,0-10.88-.68-14.16-2.03v-3.51c3.63,1.54,8.26,2.31,13.88,2.31,4.13,0,7.41-.95,9.84-2.84s3.63-4.38,3.63-7.46c0-1.91-.4-3.49-1.21-4.74s-2.11-2.39-3.93-3.43-4.48-2.15-7.99-3.34c-5.14-1.77-8.7-3.68-10.66-5.74s-2.95-4.79-2.95-8.22c0-3.77,1.48-6.84,4.43-9.22s6.75-3.57,11.39-3.57,9.18.9,13.33,2.69l-1.27,3.03c-4.18-1.75-8.18-2.62-11.99-2.62s-6.68.86-8.89,2.58-3.31,4.07-3.31,7.03c0,1.86.34,3.39,1.02,4.58s1.79,2.27,3.32,3.22,4.18,2.1,7.92,3.43c3.93,1.36,6.88,2.67,8.85,3.94s3.42,2.72,4.32,4.34,1.36,3.58,1.36,5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m410.4,414.28h-3.55v-47.06h-16.36v-3.31h36.28v3.31h-16.36v47.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.25,452.52c0,7.99-2,14.31-5.99,18.97s-9.51,6.98-16.54,6.98-12.51-2.33-16.5-6.98-5.99-11-5.99-19.03,2.02-14.33,6.05-18.93,9.54-6.91,16.52-6.91,12.53,2.31,16.5,6.94,5.96,10.95,5.96,18.97Zm-41.2,0c0,7.21,1.61,12.79,4.82,16.73s7.83,5.91,13.85,5.91,10.7-1.95,13.9-5.86,4.81-9.5,4.81-16.78-1.6-12.82-4.81-16.69-7.81-5.8-13.83-5.8-10.62,1.95-13.87,5.86-4.87,9.45-4.87,16.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.82,477.78h-3.51v-50.37h27.6v3.24h-24.08v21.36h22.74v3.27h-22.74v22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m125.13,477.78v-50.37h3.51v47.06h24.01v3.31h-27.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m157.81,477.78v-50.37h3.51v50.37h-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m201.9,427.41h3.82l-18.84,50.37h-3.1l-18.78-50.37h3.76l12.68,34.28c1.93,5.17,3.23,9.05,3.89,11.64.46-1.72,1.37-4.4,2.72-8.03l13.85-37.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m209.32,477.78v-50.37h3.51v50.37h-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m260.27,477.78h-3.55l-29.83-44.72h-.28c.28,5.33.41,9.35.41,12.06v32.66h-3.38v-50.37h3.51l29.8,44.65h.21c-.21-4.13-.31-8.06-.31-11.78v-32.87h3.41v50.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m290.81,452.39h18.57v22.98c-4.87,2.07-10.35,3.1-16.43,3.1-7.95,0-14.04-2.25-18.28-6.74s-6.36-10.85-6.36-19.07c0-5.12,1.05-9.66,3.15-13.63s5.11-7.02,9.03-9.18c3.92-2.16,8.41-3.24,13.49-3.24,5.49,0,10.42,1.01,14.78,3.03l-1.41,3.17c-4.36-2.02-8.89-3.03-13.57-3.03-6.64,0-11.9,2.05-15.8,6.15-3.89,4.1-5.84,9.63-5.84,16.59,0,7.58,1.85,13.28,5.55,17.1,3.7,3.82,9.13,5.74,16.3,5.74,4.64,0,8.58-.65,11.82-1.96v-17.71h-14.99v-3.31Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCec);
export default __webpack_public_path__ + "static/media/cec.8ae20a331c87f6372521e1878def82eb.svg";
export { ForwardRef as ReactComponent };